import React from 'react'
import { PictureAsPdf as PictureAsPdfIcon, Attachment as AttachmentIcon } from '@mui/icons-material'
import { Avatar } from '@mui/material'

const CDN = 'https://ucarecdn.com/'

const getFileExtension = fileName => {
  const name = fileName?.split('.') || ''
  if (name.length < 2) return null
  return name.pop().toLowerCase()
}

const isImage = extension => ['jpeg', 'png', 'svg', 'jpg'].includes(extension)

export const getAvatarFile = (fileName, fileUrl) => {
  const extension = getFileExtension(fileName)
  if (extension === 'pdf') {
    return (
      <Avatar variant="rounded">
        <PictureAsPdfIcon />
      </Avatar>
    )
  }
  if (isImage(extension)) {
    return <Avatar variant="rounded" src={fileUrl} />
  }
  return (
    <Avatar variant="rounded">
      <AttachmentIcon />
    </Avatar>
  )
}

export const getDownloadUrl = uuid => {
  const noinline = '/-/inline/no/'
  return `${CDN}${uuid}${noinline}`
}
